import { Alert, Badge } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import { INodeNoteCommissionDetail } from '../../../../types/commissionReportDetailApi'

export const ContentNotes = ({ notes }: { notes: INodeNoteCommissionDetail[] | undefined }) => {
  const intl = useIntl()
  if (!notes) return null

  return (
    <div className='d-flex flex-column gap-4'>
      {notes.length === 0 && (
        <Alert variant='primary'>
          <i className='fa fa-exclamation-circle me-1' style={{ color: 'inherit' }} />
          <FormattedMessage id='commissions.detail.notes.empty' defaultMessage='There are no notes or claims on this commission report detail.' />
        </Alert>
      )}

      {notes.map((note) => (
        <div key={note.id} className='border rounded p-3 bg-white'>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <div className='fw-bold'>
              {note.user.firstName} {note.user.lastName}
              <span className='text-muted ms-2' style={{ fontSize: '0.85em' }}>
                {moment(note.created).format('MMM DD, YYYY • hh:mm A')}
              </span>
            </div>
            <div className='d-flex gap-2'>
              <Badge bg={note.noteType === 'CLAIM' ? 'danger' : 'secondary'}>
                {note.noteType === 'CLAIM'
                  ? intl.formatMessage({id: 'commissions.detail.notes.claim', defaultMessage: 'CLAIM'})
                  : intl.formatMessage({id: 'commissions.detail.notes.comment', defaultMessage: 'COMMENT'})}
              </Badge>
              {note.claimReason && (
                <Badge bg='warning' text='dark'>
                  {note.claimReason.replaceAll('_', ' ')}
                </Badge>
              )}
            </div>
          </div>
          <div
            className='mt-2'
            dangerouslySetInnerHTML={{ __html: note.comments }}
          />
        </div>
      ))}
    </div>
  )
}